const PARAMETER_REGEX = /\{\{\s?(\S+)\s?\}\}/g;

export function extractParameters(template: string) {
  return Array.from(template.matchAll(PARAMETER_REGEX)).map(
    (match) => match[1]
  );
}
